import React, { useRef, useState, useEffect } from 'react';
import "./Events.css";
function useInView() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setInView(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
}
const events = [{
  day: 'FRI',
  date: '23',
  month: 'MAY',
  title: 'Jazz Under the Stars',
  time: '8PM - 11PM',
  desc: 'An evening of live jazz on the rooftop terrace. Quartet featuring some of Mysuru\'s finest musicians. Craft cocktail pairing menu available.',
  tag: 'Live Music',
  accent: '#E6D2AD'
}, {
  day: 'SAT',
  date: '24',
  month: 'MAY',
  title: 'Brew Master\'s Table',
  time: '7PM - 10PM',
  desc: 'An intimate 12-seat tasting experience hosted by our head brewer. Six-course beer pairing dinner with exclusive small-batch releases.',
  tag: 'Exclusive',
  accent: '#F5E6C9'
}, {
  day: 'SUN',
  date: '25',
  month: 'MAY',
  title: 'Sunday Slow Sessions',
  time: '1PM - 6PM',
  desc: 'Acoustic sets, bottomless brunch plates and leisurely afternoons. The best way to end your weekend.',
  tag: 'Brunch',
  accent: '#E6D2AD'
}, {
  day: 'THU',
  date: '29',
  month: 'MAY',
  title: 'Whisky & Wild Kitchen',
  time: '7:30PM - 10:30PM',
  desc: 'Master blender in residence presents a curated whisky flight alongside our chef\'s specially designed tasting menu.',
  tag: 'Tasting',
  accent: '#F5E6C9'
}];
export default function Events() {
  const [ref, inView] = useInView();
  const [hovered, setHovered] = useState(null);
  return <section id="events" ref={ref} className="events__auto-1">
      {/* Vertical line accent */}
      <div className="events__auto-2" />

      <div className="events__auto-3">
        {/* Header */}
        <div style={{
        textAlign: 'center',
        marginBottom: 'clamp(26px, 4vw, 42px)',
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)',
        transition: 'all 0.8s ease'
      }}>
          <div className="events__auto-4">
            <div className="events__auto-5" />
            <span className="events__auto-6">What's On</span>
            <div className="events__auto-7" />
          </div>
          <h2 className="events__auto-8">
            Upcoming Events
          </h2>
        </div>

        {/* Events list */}
        <div className="events__auto-9">
          {events.map((ev, i) => <div key={i} onMouseEnter={() => setHovered(i)} onMouseLeave={() => setHovered(null)} style={{
          background: hovered === i ? '#1A1A1A' : '#0B0B0B',
          display: 'grid',
          gridTemplateColumns: 'auto 1fr auto',
          gap: 'clamp(16px, 3vw, 34px)',
          alignItems: 'center',
          padding: 'clamp(14px, 1.8vw, 22px) clamp(18px, 3vw, 34px)',
          transition: 'background 0.3s ease',
          cursor: 'default',
          opacity: inView ? 1 : 0,
          transform: inView ? 'translateX(0)' : 'translateX(-20px)',
          transitionDelay: `${i * 0.1 + 0.3}s`,
          transitionDuration: '0.7s'
        }}>
              {/* Date block */}
              <div className="events__auto-10">
                <div style={{
              fontFamily: "'Jost', sans-serif",
              fontSize: '13px',
              letterSpacing: '3px',
              color: ev.accent,
              textTransform: 'uppercase',
              marginBottom: '4px'
            }}>
                  {ev.day}
                </div>
                <div className="events__auto-11">
                  {ev.date}
                </div>
                <div className="events__auto-12">
                  {ev.month}
                </div>
              </div>

              {/* Details */}
              <div>
                <div className="events__auto-13">
                  <span style={{
                fontFamily: "'Jost', sans-serif",
                fontSize: '18px',
                letterSpacing: '2px',
                color: ev.accent,
                border: `1px solid ${ev.accent}`,
                opacity: 0.7,
                padding: '2px 8px',
                textTransform: 'uppercase'
              }}>
                    {ev.tag}
                  </span>
                  <span className="events__auto-14">
                    {ev.time}
                  </span>
                </div>
                <h3 className="events__auto-15">
                  {ev.title}
                </h3>
                <p className="events__auto-16">
                  {ev.desc}
                </p>
              </div>

              {/* CTA */}
              <div className="events__auto-17">
                <button style={{
              fontFamily: "'Jost', sans-serif",
              fontSize: '19px',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              padding: '12px 24px',
              border: `1px solid ${hovered === i ? '#9A321D' : 'rgba(230,210,173,0.2)'}`,
              background: hovered === i ? '#711d10' : 'transparent',
              color: hovered === i ? '#E8DDC3' : 'rgba(255,246,232,0.62)',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              whiteSpace: 'nowrap',
              boxShadow: hovered === i ? '0 12px 34px rgba(113, 29, 16, 0.36)' : 'none'
            }}>
                  Reserve
                </button>
              </div>
            </div>)}
        </div>

        <div style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '48px',
        opacity: inView ? 1 : 0,
        transition: 'opacity 0.8s ease 0.7s'
      }}>
          <button className="events__auto-18">
            View All Events
          </button>
        </div>
      </div>
    </section>;
}
